export class Entity {
    constructor(props) {
        this.props = props;
    }

    getId() {
        return this.props._id;
    }

    setId(_id) {
        this.props._id = _id;
    }

    getProps() {
        return this.props;
    }
}
